/* eslint-disable max-len */
// ==============================================
// ==================Import======================
// ==============================================

// ==================Hooks REACT===================
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

// ==================Components===================
import Spinner2 from '../Spinner2';

// ==================Style&IMG===================
import './style.scss';

// ==================Actions===================
import {
  fetchNodeInfoMapPage,
  fetchNodeInfoTabPage,
  setLoadingNodeInfoMap,
  setLoadingNodeInfoTab,
} from '../../actions/nodeInfo';

// ==================Components===================
import NodeInfoMap from './NodeInfoMap';
import NodeInfoTab from './NodeInfoTab';

// ==================External configuration===================
import { globalConfig } from '../../configuration/config';

function NodeInfo() {
// ==================HOOK===================
  const dispatch = useDispatch();
  const loadingNodeInfoMap = useSelector((state) => state.nodeInfo.nodeInfoPage.loadingNodeInfoMap);
  const loadingNodeInfoTab = useSelector((state) => state.nodeInfo.nodeInfoPage.loadingNodeInfoTab);
  const nodeInfoMap = useSelector((state) => state.nodeInfo.nodeInfoPage.nodeInfoMap);
  const nodeInfoTab = useSelector((state) => state.nodeInfo.nodeInfoPage.nodeInfoTab);
  const allPages = useSelector((state) => state.site.allPages);

  useEffect(() => {
    if (allPages.length > 0) {
      const pagesToDisplayToFetchMap = allPages.find(
        (el) => el.meta.slug === 'epos-gnss-node-infrastructure',
      );
      dispatch(fetchNodeInfoMapPage(pagesToDisplayToFetchMap.id, globalConfig.config.REACT_APP_BACKEND_API));
      const pagesToDisplayToFetchTab = allPages.find(
        (el) => el.meta.slug === 'how-to-become-a-node',
      );
      dispatch(fetchNodeInfoTabPage(pagesToDisplayToFetchTab.id, globalConfig.config.REACT_APP_BACKEND_API));
    }
    dispatch(setLoadingNodeInfoMap(true));
    dispatch(setLoadingNodeInfoTab(true));
  }, [allPages]);

  return (
    <>
      {/* if API is OK */}
      {(
        (loadingNodeInfoMap)
        || (loadingNodeInfoTab))
        && <Spinner2 />}
      {(
        (!loadingNodeInfoMap && nodeInfoMap.map_node !== undefined))
        && <NodeInfoMap nodeInfoMap={nodeInfoMap} />}
      {(
        (!loadingNodeInfoTab && nodeInfoTab.block_table !== undefined)
        && !loadingNodeInfoMap && nodeInfoMap.map_node !== undefined)
        && <NodeInfoTab nodeInfoTab={nodeInfoTab} nodeInfoMap={nodeInfoMap} />}
    </>
  );
}

export default NodeInfo;
